type TGetTotalTimeFn = (startTime: number, inSeconds?: boolean) => number

/**
 * `useDurationTime` returns the start time (by invoking `getStartTime`) and
 * the total time (by invoking `getTotalTime`) an action took.
 *
 * `getTotalTime` returns by default result in milliseconds but by passing
 * `inSeconds` as `true` it returns result in seconds.
 *
 */
export const useDurationTime = (): {
  getStartTime: () => number
  getTotalTime: TGetTotalTimeFn
} => {
  const getStartTime = () => performance.now()

  const getTotalTime: TGetTotalTimeFn = (startTime, inSeconds) => {
    const currentTime = performance.now()
    const totalTime = currentTime - startTime

    if (inSeconds) {
      return totalTime / 1000
    }

    return totalTime
  }

  return { getStartTime, getTotalTime }
}
